import type { ExtraWallet } from '../../types/extraWallets';

export const getIsWalletBonusCash = (wallet?: ExtraWallet) => wallet?.awardingType === 'REDEEMABLE';
export const getIsWalletFreeBet = (wallet?: ExtraWallet) =>
  wallet?.awardingType === 'NON_REDEEMABLE';
